import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Select from '../../shared/reactSelect/select.component';

import {
  extraReportingCurrencyCodesSelector,
  reportingCurrencyCodeSelector,
} from '../../shared/store/selectors';

import { selectReportingCurrencyCode } from '../../shared/store/actions';

class ReportingCurrencySelect extends PureComponent {
  static propTypes = {
    reportingCurrencyCode: PropTypes.string.isRequired,
    reportingCurrencyCodes: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    selectReportingCurrencyCode: PropTypes.func.isRequired,

    disabled: PropTypes.bool,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    disabled: false,
  };

  selectReportingCurrencyCode = selectedReportingCurrencyCode => {
    this.props.selectReportingCurrencyCode(selectedReportingCurrencyCode.value);
    if (this.props.onChange) {
      this.props.onChange(selectedReportingCurrencyCode);
    }
  };

  render() {
    const {
      reportingCurrencyCode,
      reportingCurrencyCodes,
      disabled,
    } = this.props;

    return (
      <Select
        className="form-control select-currency str-select"
        clearable={false}
        options={reportingCurrencyCodes}
        value={reportingCurrencyCode}
        onChange={this.selectReportingCurrencyCode}
        disabled={disabled}
        labelKey="label"
      />
    );
  }
}

export default connect(
  function mapStateToProps(state) {
    return {
      reportingCurrencyCodes: extraReportingCurrencyCodesSelector(['Functional Currency'])(state),
      reportingCurrencyCode: reportingCurrencyCodeSelector(state),
    };
  },
  {
    selectReportingCurrencyCode,
  }
)(ReportingCurrencySelect);
